import { useFleetHealth } from '@/api/hooks/useDashboards';
import { FleetHealthTiles } from '@/components/dashboards/FleetHealthTiles';

/**
 * /app/fleet-health — spec §13's six-tile fleet data-trust panel (missing
 * baselines, missing location, midnight-timestamp ingest bug, missing
 * make/model/year, baseline freshness, composite trust score). Backed by
 * `GET /api/v1/dashboards/fleet-health` (Plan 5 / Task 3), fixed to "this
 * month" per the endpoint's contract.
 */
export default function FleetHealth(): JSX.Element {
  const { data, isLoading, error } = useFleetHealth();

  return (
    <div className="flex h-full flex-col gap-4">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Fleet Health</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Data-trust panel — how much to trust this month&apos;s fraud alerts
          given known data gaps.
        </p>
      </div>

      <FleetHealthTiles
        kpis={data?.kpis}
        isLoading={isLoading}
        error={(error as Error) ?? null}
      />
    </div>
  );
}
